import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { AuthEffects, AuthInterceptor, AuthService, authReducer } from '@lib/auth';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';

import { environment } from '@protocols/environments/environment';

import { provideTranslateModule } from '@lib/core/translate/translate.provider';

import { AUTH_API_URL } from '../../../../packages/core/src/tokens/api.tokens';
import { routes } from './app.routes';

export function initializeTokens(authService: AuthService) {
  return () => authService.initializeTokens();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideStore({ auth: authReducer }),
    provideEffects([AuthEffects]),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    provideTranslateModule(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTokens,
      deps: [AuthService],
      multi: true,
    },
    { provide: AUTH_API_URL, useValue: environment.authorizationApiUrl },
  ],
};
